import { images } from '../constants';

const process = [ 
    {
        id: 1,
        image: images.step1,
        title: 'Assessment',
        content: 'Thorough assessment of your flooring, tiling, or paving needs to understand the scope of the project.',
    },
    {
        id: 2,
        image: images.step2,
        title: 'Design',
        content: 'Professional design and planning of flooring, tiling, or paving layouts tailored to your space and preferences.',
    },
    {
        id: 3,
        image: images.step3,
        title: 'Installation',
        content: 'Skilled and precise installation of flooring, tiling, or paving materials using industry-leading techniques.',
    },
    {
        id: 4,
        image: images.step4,
        title: 'Quality Check',
        content: 'Thorough inspection and testing to ensure the durability, integrity, and quality of the installed surfaces.',
    },
    {
        id: 5,
        image: images.step5,
        title: 'Finishing',
        content: 'Application of professional finishes to enhance the appearance and protect the surfaces from wear and tear.',
    },
    {
        id: 6,
        image: images.step6,
        title: 'Client Satisfaction',
        content: 'Ensuring your satisfaction with the completed project through thorough inspection and final approval.',
    },
];  

export default process;